import { useEffect, useState } from "react";
import "./hero.css";
import { useHomeContent } from "../../hooks/useHomeContent";
import { FeedbackModal } from "../../../../components/landing/modals/FeedbackModal/FeedbackModal";

type HeroButton = {
  text?: string;
  action?: "feedback" | "anchor";
  anchor?: string;
};

export const Hero = () => {
  const data = useHomeContent();
  const [open, setOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const calc = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", calc);
    return () => window.removeEventListener("resize", calc);
  }, []);

  const hero = data?.hero;
  if (!hero) return null;

  const feedbackModal = data.feedbackModal ?? {};
  const bg = isMobile ? hero.bannerMobile : hero.bannerDesktop;
  const buttons = (hero.buttons ?? []) as HeroButton[];

  const actionButton =
    buttons.find((b) => b.action === "feedback") ?? buttons[0] ?? {};
  const anchorButton =
    buttons.find((b) => b.action === "anchor" || !!b.anchor) ?? buttons[1] ?? {};

  return (
    <>
      <section className="oc-hero" style={{ backgroundImage: `url(${bg})` }}>
        <div className="oc-hero__overlay" />

        <div className="oc-container">
          <div className="oc-hero__wrap">
            <h1 className="oc-hero__h1">
              {hero.titlePrefix}{" "}
              <span className="oc-hero__accent">{hero.titleAccent}</span>
            </h1>

            <div className="oc-hero__sub">{hero.subtitle}</div>

            <div className="oc-hero__actions">
              {!!anchorButton.anchor && (
                <a
                  className="oc-btn oc-btn--gray oc-btn--lg oc-hero__btn"
                  href={anchorButton.anchor}
                >
                  {anchorButton.text}
                </a>
              )}

              <button
                className="oc-btn oc-btn--primary oc-btn--lg oc-hero__btn"
                onClick={() => setOpen(true)}
                type="button"
              >
                {actionButton.text ?? hero.feedbackButtonLabel ?? data?.common?.send ?? ""}
              </button>
            </div>
          </div>
        </div>
      </section>

      <FeedbackModal
        open={open}
        onClose={() => setOpen(false)}
        title={hero.feedbackModalTitle ?? feedbackModal.title}
        thanksText={hero.feedbackModalThanksText ?? feedbackModal.thanksText}
        submitLabel={hero.feedbackModalSubmitLabel ?? feedbackModal.submitLabel}
        formCopy={data.feedbackForm}
      />
    </>
  );
};
